<template>
  <div class="">
    <!-- Breadcrumb -->
    <b-breadcrumb
      v-if="breadCrumbItems && breadCrumbItems.length"
      :items="breadCrumbItems"/>
    <!-- IL-Frame -->
    <il-frame
      v-if="selectedNode && selectedNode.parent && !selectedNode.goalNode && !selectedNode.hasChildren()"
      @update="treeUpdated(selectedNode)"/>
    <!-- Terminal banner -->
    <b-alert
      v-else-if="isPhone === false"
      variant="info"
      show>
      <span v-if="selectedNode && selectedNode.parent && !selectedNode.goalNode">
        The IL-Frame can be evaluated only on terminal nodes, i.e. nodes without descendants
      </span>
      <span v-else-if="selectedNode && selectedNode.goalNode === true">
        Add alternatives by using
      <font-awesome-icon icon="plus"
                     size="xs" />
      </span>
      <span v-else>
        Add alternatives by using
        <font-awesome-icon
          icon="plus"
          size="xs"/>
      </span>
    </b-alert>
    <!-- Disable control -->
    <div
      v-if="selectedNode && selectedNode.parent && !selectedNode.goalNode"
      class="pl-1">
      <p class="text-justify mt-0">
        This {{getNodeLabel(selectedNode).single}} can be temporally excluded from the evaluation process by checking the mark below.
      </p>
      <b-form-checkbox
        v-model="selectedNode.disabled"
        @change="nodeDisabled(selectedNode)">
        Disable <strong>{{selectedNode.label}}</strong> {{getNodeLabel(selectedNode).single}}
      </b-form-checkbox>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getNodeLabel } from '@/utils'
import ILFrame from '@/components/IL-Frame.vue'

export default {
  name: 'FramePanel',
  props: {
    treeUpdated: {
      type: Function,
      default: () => {}
    }
  },
  components: {
    'il-frame': ILFrame
  },
  methods: {
    getNodeLabel,
    nodeDisabled (node) {
      this.$nextTick(() => {
        node.state.expanded = !node.disabled
        this.treeUpdated(node)
      })
    }
  },
  computed: {
    ...mapGetters(['selectedNode']),
    breadCrumbItems () {
      const items = []
      let node = this.selectedNode
      while (node && node.label) {
        items.unshift(node.label)
        node = node.parent
      }
      return items.map(i => ({
        text: i,
        disabled: true,
        active: true
      }))
    },
    isPhone () {
      return ['xs', 'sm'].includes(this.$mq)
    }
  }
}
</script>

<style lang="scss" scoped>
.breadcrumb {
  li.active {
    color: black;
    font-weight: bold;
  }
  background-color: rgba(0, 0, 0, 0) !important;
  border: 1px solid black;
}
</style>
